import { render, staticRenderFns } from "./InvestCountBoard.vue?vue&type=template&id=cf3266b0&scoped=true&"
import script from "./InvestCountBoard.vue?vue&type=script&lang=js&"
export * from "./InvestCountBoard.vue?vue&type=script&lang=js&"
import style0 from "./InvestCountBoard.vue?vue&type=style&index=0&id=cf3266b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf3266b0",
  null
  
)

export default component.exports